export default __webpack_public_path__ + "static/media/gymnast.26442dce.png";